import React, { Component } from 'react';
import { Row, Col, Tabs, Card, List, Avatar, Skeleton, Alert } from 'antd';
import { DayOfWeek, MealType } from '../../../../components/Label';
import AddButton from '../grocery-list/AddButton';
import { NavLink } from 'react-router-dom'

export default class Week extends Component {
    constructor(props) {
        super(props);

        this.state = {
            today: this.nowToDayOfWeek()
        };
    }

    nowToDayOfWeek = () => {
        const now = new Date();
        let dayOfWeek;
        switch (now.getDay()) {
            case 0:
                dayOfWeek = 'SUNDAY';
                break;
            case 1:
                dayOfWeek = 'MONDAY';
                break;
            case 2:
                dayOfWeek = 'TUESDAY';
                break;
            case 3:
                dayOfWeek = 'WEDNESDAY';
                break;
            case 4:
                dayOfWeek = 'THURSDAY';
                break;
            case 5:
                dayOfWeek = 'FRIDAY';
                break;
            case 6:
                dayOfWeek = 'SATURDAY';
                break;
            default:
                dayOfWeek = 'UNKNOWN';

        }
        return dayOfWeek;
    }

    hasMealForToday = (menu) => {
        const { today } = this.state;
        let hasMeal = false;

        menu._embedded['varma:days'].data.forEach(d => {
            if (d.day_of_week === today) {
                hasMeal = true;
            }
        });
        return hasMeal;
    }

    groupMeals = (meals) => {
        const grouped = {};
        meals.forEach(m => {
            if (!grouped[m.type]) {
                grouped[m.type] = [];
            }
            grouped[m.type].push(m);
        });

        const filtered = {};
        if (grouped['BREAKFAST']) {
            filtered['BREAKFAST'] = grouped['BREAKFAST'];
        }
        if (grouped['LUNCH']) {
            filtered['LUNCH'] = grouped['LUNCH'];
        }
        if (grouped['DINNER']) {
            filtered['DINNER'] = grouped['DINNER'];
        }
        return filtered;
    }

    render() {
        const { menu, loading } = this.props;
        let { today } = this.state
        if (!menu._embedded) {
            menu._embedded = { 'varma:days': { data: [] } };
        }

        if (menu._embedded['varma:days'].data.length) {
            today = this.hasMealForToday(menu) ? today : menu._embedded['varma:days'].data[0].day_of_week;
        }
        
        return (
            <div>
                {loading && (
                    <Tabs>
                        <Tabs.TabPane key="loading" tab="Laddar...">
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Card>
                                        <Skeleton title={false} avatar active />
                                    </Card>
                                </Col>
                            </Row>
                        </Tabs.TabPane>
                    </Tabs>
                )}
                
                <Tabs activeKey={today} onChange={key => this.setState({ today: key })}>
                    {menu._embedded['varma:days'].data.map(d => (
                        <Tabs.TabPane key={d.day_of_week} tab={this.nowToDayOfWeek() === d.day_of_week ? 'Idag' : DayOfWeek({ type: d.day_of_week })}>
                            <Row gutter={16}>
                                {Object.keys(this.groupMeals(d.meals)).map(key => (
                                    <Col key={key} xs={24} md={8}>
                                        <Card title={<MealType type={key} />}>
                                            <List
                                                itemLayout="horizontal"
                                                dataSource={this.groupMeals(d.meals)[key]}
                                                renderItem={item => (
                                                    <List.Item>
                                                        <List.Item.Meta
                                                            avatar={<Avatar size="large" src={item.recipe.image} />}
                                                            title={<NavLink to={`/recipes/${item.recipe.id}`}>{item.recipe.title}</NavLink>}
                                                        />
                                                    </List.Item>
                                                )}
                                            />
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Tabs.TabPane>
                    ))}
                </Tabs>
                
                {menu.id && <AddButton style={{ marginTop: '20px' }} menu={menu} />}

                {menu.note && (
                    <Alert
                        style={{marginTop: '20px'}}
                        message="Att tänka på"
                        description={menu.note}
                        type="info"
                        showIcon
                  />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/components/menu/Week.js